import React from "react";
import { Link } from "react-router-dom";
import Button from "../../button/Button";

import "./Landing.css";

const scrollToFeatures = () => {
    const target = document.getElementById("features-section");
    if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};

const Landing = () => {
    return (
        <div className="landing-div">
            <div className="landing">
                <img src={require("../../../assets/images/landig_background.png")} id="background" alt=""/>
                <div className="description">
                    <div className="title">
                        <h3>Learn Math</h3><div className="highlight"><h3>Interactively!</h3></div>
                    </div>
                    <div className="description-text">
                        <p>We stimulate your thinking and we hold you from solution-peeking 👀 with our Progressive Hinting 💡 and Dynamic Solution 📐 approaches!</p>
                    </div>
                    <div className="landing-cta-row">
                        <Link to="/titles" style={{ textDecoration: 'none' }}>
                            <Button text="Getting Started" newTab={false} href=""/>
                        </Link>
                        <button
                            type="button"
                            className="landing-secondary-cta"
                            onClick={scrollToFeatures}
                        >
                            How it works ↓
                        </button>
                    </div>

                    <ul className="landing-value-strip" aria-label="What you get">
                        <li>
                            <span className="landing-value-icon" aria-hidden="true">💡</span>
                            <span className="landing-value-text">Progressive hints</span>
                        </li>
                        <li>
                            <span className="landing-value-icon" aria-hidden="true">📐</span>
                            <span className="landing-value-text">Dynamic solutions</span>
                        </li>
                        <li>
                            <span className="landing-value-icon" aria-hidden="true">🖊️</span>
                            <span className="landing-value-text">Drawing canvas</span>
                        </li>
                        <li>
                            <span className="landing-value-icon" aria-hidden="true">🗺️</span>
                            <span className="landing-value-text">Mind Maps</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Landing;
